var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5763 1.45064C11.8106 1.21632 12.1905 1.21632 12.4249 1.45064L16.9249 5.95064C17.1592 6.18495 17.1592 6.56485 16.9249 6.79917C16.6905 7.03348 16.3106 7.03348 16.0763 6.79917L12.6004 3.32323V13.1249C12.6004 13.4563 12.3318 13.7249 12.0004 13.7249C11.669 13.7249 11.4004 13.4563 11.4004 13.1249V3.32363L7.92485 6.79917C7.69054 7.03348 7.31064 7.03348 7.07632 6.79917C6.84201 6.56485 6.84201 6.18495 7.07632 5.95064L11.5763 1.45064ZM4.12539 11.3499C3.83544 11.3499 3.60039 11.585 3.60039 11.8749V20.9999C3.60039 21.2899 3.83544 21.5249 4.12539 21.5249H19.8754C20.1653 21.5249 20.4004 21.2899 20.4004 20.9999V11.8749C20.4004 11.585 20.1653 11.3499 19.8754 11.3499H17.6254C17.294 11.3499 17.0254 11.0813 17.0254 10.7499C17.0254 10.4185 17.294 10.1499 17.6254 10.1499H19.8754C20.8281 10.1499 21.6004 10.9222 21.6004 11.8749V20.9999C21.6004 21.9526 20.8281 22.7249 19.8754 22.7249H4.12539C3.1727 22.7249 2.40039 21.9526 2.40039 20.9999V11.8749C2.40039 10.9222 3.1727 10.1499 4.12539 10.1499H6.37539C6.70676 10.1499 6.97539 10.4185 6.97539 10.7499C6.97539 11.0813 6.70676 11.3499 6.37539 11.3499H4.12539Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare24);
export default __webpack_public_path__ + "static/media/share-24.d2e51fc1c78563c3ab3f4389e0c3b2cd.svg";
export { ForwardRef as ReactComponent };